import axios from 'axios';
import { BaseApiService } from '@/services/backend/base';

export class PersonalRatingHistoryAPIService extends BaseApiService {
    constructor() {
        super('personal/rating_history');
    }

    async getList(isCustomerRating) {
        try {
            const response = await axios.get(this.getUrl(), { params: { is_customer_rating: isCustomerRating } });
            return response.data;
        } catch (err) {
            this.handleErrors(err);
            throw err;
        }
    }
}
